/** Tiny localStorage helpers for Grade 3 workbook player (no backend). */

/** TOC / workbook completion tri-state for one activity. */
export type WorkbookActivityCompletion = 'not_started' | 'in_progress' | 'completed';

/** Last recorded score (0–100) for a workbook activity, keyed by `persistenceId`. */
export type ActivityScoreRecord = { pct: number; at: string };

export const TKM_G3_TOC_COMPLETION_KEY = 'tkm-g3-toc-completion-v1';

export const TKM_G3_ACTIVITY_SCORES_KEY = 'tkm-g3-activity-scores-v1';

export function readActivityScores(): Record<string, ActivityScoreRecord> {
  return readWorkbookJson<Record<string, ActivityScoreRecord>>(TKM_G3_ACTIVITY_SCORES_KEY, {});
}

export function writeActivityScore(persistenceId: string, pct: number): void {
  const id = persistenceId.trim();
  if (!id) return;
  const all = { ...readActivityScores() };
  const clamped = Math.max(0, Math.min(100, Math.round(Number.isFinite(pct) ? pct : 0)));
  all[id] = { pct: clamped, at: new Date().toISOString() };
  writeWorkbookJson(TKM_G3_ACTIVITY_SCORES_KEY, all);
  try {
    window.dispatchEvent(new CustomEvent('tkm-g3-scores-updated'));
  } catch {
    /* ignore */
  }
}

export function clearActivityScore(persistenceId: string): void {
  const id = persistenceId.trim();
  if (!id) return;
  const all = { ...readActivityScores() };
  delete all[id];
  writeWorkbookJson(TKM_G3_ACTIVITY_SCORES_KEY, all);
  try {
    window.dispatchEvent(new CustomEvent('tkm-g3-scores-updated'));
  } catch {
    /* ignore */
  }
}

export function readWorkbookJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw) return JSON.parse(raw) as T;
  } catch {
    /* ignore */
  }
  return fallback;
}

export function writeWorkbookJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore */
  }
}
